import CompanyLogo from "~/components/CompanyLogo";

const HeaderNoProfile = () => (
  <header className="bg-white">
    <nav aria-label="Global" className="sticky top-0 z-40 lg:mx-auto">
      <div className="flex h-16 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8 lg:shadow-none">
        <div className="flex shrink-0 items-center">
          <CompanyLogo />
        </div>
      </div>
    </nav>
  </header>
);

export default HeaderNoProfile;
